'use strict'

/**
 * Crossplatform Date.now()
 *
 * @return {Number} time in ms
 * @api private
 */
module.exports = Date.now || function() {
  return (new Date).getTime()
}



//////////////////
// WEBPACK FOOTER
// ./~/animation-frame/lib/now.js
// module id = 8
// module chunks = 0